<!-- STAR HEADER SEARCH -->
<section id="hero-area" [style.background]="'none !important'"
    class="parallax-searchs home-desktop home15 overlay thome-6 thome-1">
    <div class="home-background">
        <ngb-carousel class="w-100 h-100" [interval]="5000" *ngIf="images.length > 0" [showNavigationArrows]="false"
            [showNavigationIndicators]="false">
            <ng-template ngbSlide *ngFor="let img of images; let i = index">
                <img alt="slide-{{i}}" [src]="img">
            </ng-template>
        </ngb-carousel>
    </div>
    <div class="hero-main">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="hero-inner">
                        <!-- Welcome Text -->
                        <div [ngClass]="{'mb-5': homeTexts.title && !homeTexts.subtitle}"
                            class="welcome-text">
                            <h1 *ngIf="homeTexts?.title" class="h1 first-title-home">{{homeTexts.title}}
                                <br class="d-md-none">
                                <!-- <span class="typed border-bottom"></span> -->
                            </h1>
                            <p *ngIf="homeTexts?.subtitle" class="mt-4 fs-3">{{homeTexts.subtitle}}</p>
                        </div>
                        <!--/ End Welcome Text -->
                        <!-- Search Form -->
                        <form (ngSubmit)="generalSearch()" class="row justify-content-center">
                            <div class="search-input col-5 position-relative">
                                <input [placeholder]="'HOME.SEARCH.PLACEHOLDER.TEXT' | translate" autocomplete="off"
                                    [style.border-radius]="searchResult.length > 0 ? '6px 6px 0 0' : '6px'"
                                    [formControl]="inputSearch" name="search-value" class="form-control">
                                <ion-icon class="main-color" name="search-outline"></ion-icon>
                                <button type="submit" class="search-button">{{"HOME.SEARCH.TEXT" | translate}}</button>
                                <div class="search-auto-complete">
                                    <div class="position-relative">
                                        <ul *ngIf="searchResult.length > 0" class="search-results position-static">
                                            <li class="results-number position-absolute text-start bg-white">
                                                <ion-icon name="location-outline"></ion-icon><span
                                                    class="ms-5">{{searchResult.length}}
                                                    <span *ngIf="searchResult.length === 1"> {{'t-location' |
                                                        translate}}</span>
                                                    <span *ngIf="searchResult.length > 1"> {{'t-locations' |
                                                        translate}}</span>
                                                </span>
                                            </li>
                                            <li class *ngFor="let result of searchResult; let i = index"
                                                (click)="inputSearch.setValue(result.name); searchResult = []; searchByLocation(result.id)"
                                                class="option-result text-start" [ngClass]="{'mt-5':i === 0}"><span
                                                    class="result-title">{{result.name}}</span><br><span
                                                    class="result-subtitle">{{result.type | translate}}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="advanced-search">
                                <button (click)="openModal()" type="button"
                                    class="btn w-auto fs-3 d-flex align-items-center justify-content-center"><ion-icon
                                        class="filter-icon main-color" name="options-outline"></ion-icon></button>
                            </div>
                        </form>
                        <app-advanced-search-home [searchData]="searchData"></app-advanced-search-home>
                        <!--/ End Search Form -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- END HEADER SEARCH -->
